module.exports = __webpack_public_path__ + "img/1_031.4a6c2047.jpg";